import { render } from "./Questions.vue?vue&type=template&id=3f9af7f0&scoped=true&lang=pug"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=3f9af7f0&lang=scss&scoped=true"
import "./Questions.vue?vue&type=style&index=1&id=3f9af7f0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9af7f0"]])

export default __exports__